import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import type { RootState } from '../../store';

// Define a type for the slice state

interface ClaimProps {
  id: number;
  type: string;
  value: string;
  isActive: boolean;
}

interface AuthProps {
  user?: any;
  authPending: boolean;
  claims: ClaimProps[];
}

// Define the initial state using that type
const initialState: AuthProps = {
  user: null,
  authPending: false,
  claims: [],
};

export const authSlice = createSlice({
  name: 'auth',
  // `createSlice` will infer the state type from the `initialState` argument
  initialState,
  reducers: {
    authNegotiate: (state) => {
      state.authPending = true;
    },
    storeUser: (state, action: PayloadAction<any>) => {
      state.authPending = false;
      state.user = action.payload;
    },
    storeClaims: (state, action: PayloadAction<any>) => {
      state.claims = action.payload;
    },
    // Use the PayloadAction type to declare the contents of `action.payload`
    unloadUser: (state) => {
      state.user = null;
      state.claims = [];
      state.authPending = false;
    },
  },
});

export const { authNegotiate, storeUser, storeClaims, unloadUser } = authSlice.actions;

// Other code such as selectors can use the imported `RootState` type
export const selectUser = (state: RootState) => state.auth.user;
export const selectClaims = (state: RootState) => state.auth.claims;
export const selectAuthPending = (state: RootState) => state.auth.authPending;

export default authSlice.reducer;
